<template>
    <RatesCardDefaultCommon />
</template>
